export default __webpack_public_path__ + "static/media/Minotaur2.cd16b3af.png";